module.exports = __webpack_public_path__ + "static/media/bell-on.14ed40d0.svg";